<template>
  <div class="header-container custom-header">
    <div class="header-container" :class="{ 'side-nav': isSideNav }">
    <div class="desktop-header d-none d-lg-block">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <router-link class="navbar-brand" :to="{ name: 'index' }" v-show="showLogo"    >
            <span class="logo-container">
              <img src="../../assets/img/logo.png" class="logo" alt="Logo" />
            </span>
          </router-link>
          <div
            class="search-input-container form-group"
            :class="[
              { 'full-width': isFullWidth, 'side-nav': isSideNav },
              componentStyle.searchInput,
            ]"
          >
            <search-bar
              :in-submit="search"
              :placeholder="$t('buttons.search')"
              :input="title"
            ></search-bar>
            <button
              type="button"
              class="btn btn-lg btnLive"
              @click="redirectLive"
              v-show="isSideNav"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#ffffff"
                width="32px"
                height="32px"
                viewBox="0 0 437.274 318.75"
                style="margin-right: 0.5em;"
              >
                <g id="noun_live_2146916" transform="translate(-2.5 -15.35)">
                  <g id="btnLiveGroupe" data-name="Groupe 2" transform="translate(2.5 15.35)">
                    <path
                      class="big-arc"
                      d="M105.4,20.183c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a186.286,186.286,0,0,1,54.314,132.1A183.759,183.759,0,0,1,82.383,306.483c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,216.869,216.869,0,0,0,63.98-154.657C169.378,116.383,146.823,61.149,105.4,20.183Z"
                      transform="translate(267.897 -15.35)"
                      fill="#ffffff"
                    />
                    <path
                      class="big-arc"
                      d="M34.72,174.48c0-50.171,19.332-96.661,54.774-131.643,6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0C25.054,60.788,2.5,116.023,2.5,174.48A216.869,216.869,0,0,0,66.48,329.137a16.685,16.685,0,0,0,23.014,0c6.444-6.444,6.444-16.57,0-22.554A185.6,185.6,0,0,1,34.72,174.48Z"
                      transform="translate(-2.5 -14.99)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M93.237,31.983c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a109.053,109.053,0,0,1,32.22,77.329,109.052,109.052,0,0,1-32.22,77.328c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,140.318,140.318,0,0,0,41.426-99.883A143.53,143.53,0,0,0,93.237,31.983Z"
                      transform="translate(225.743 27.164)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M51.06,131.966A108.261,108.261,0,0,1,83.28,54.637c6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0a141.684,141.684,0,0,0,.46,200.686A16.112,16.112,0,0,0,84.2,210.215,109.078,109.078,0,0,1,51.06,131.966Z"
                      transform="translate(58.029 27.524)"
                      fill="#ffffff"
                    />
                    <path
                      d="M63.654,38.836A14.481,14.481,0,0,0,41.1,50.8V147a14.481,14.481,0,0,0,22.554,11.967l72.265-48.33a14.621,14.621,0,0,0,0-24.4Z"
                      transform="translate(136.571 60.356)"
                    />
                  </g>
                </g>
              </svg>
              Live
            </button>
          </div>
          <div class="Rectangle">
            <div class="Connexion">
              Connexion
            </div>
          </div>
        </nav>
      </div>
      <div class="navbar-container separator" v-show="isFullWidth" :class="componentStyle.navBar">
      </div>
      <div  id="sb-menu" class="navbar-container" v-show="isFullWidth" :class="componentStyle.navBar">
        <div class="navbarList">
          <custom-menu  v-if="!NOT_LIST_THEME"
                        :items="items"
                        :current-index="currentTheme"
                        :clickItem="itemClicked"></custom-menu>
        </div>
      </div>
    </div>
    <div class="mobile-header d-lg-none">
      <nav class="navbar navbar-expand-lg navbar-light">
        <router-link class="navbar-brand" :to="{ name: 'index' }" v-show="showLogo && !isSearchInputVisible">
          <span class="logo-container">
            <img :src="getLogo" class="image_base64" alt="Logo" />
          </span>
        </router-link>
        <div id="searchbar" class="collapsed">
          <div id="search-box">
            <div id="sliding-panel-outer">
              <div id="sliding-panel-inner">
                <div
                  class="search-input-container form-group"
                  :class="[
              { 'full-width': isFullWidth, 'side-nav': isSideNav },
              componentStyle.searchInput,
            ]"
                >


                  <search-bar
                    :in-submit="search"
                    :placeholder="$t('buttons.search')"
                    @changed="keywordChanged"
                  ></search-bar>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="search-label" :class="{'closelabel':isSearchInputVisible}" >
              <span v-if="!isSearchInputVisible" class="fa fa-search" @click="clickopen"> <svg width="20px" height="20px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M3.07714695,3.07714695 C7.06999567,-0.915701775 13.5048847,-1.03818571 17.6467888,2.79982327 C21.7133854,6.56805027 22.1413639,12.8305975 18.6749451,17.1125385 L18.478358,17.348358 L18.930358,17.784358 L20.203358,17.784358 L28.253358,25.858358 L25.853358,28.258358 L17.784358,20.205358 L17.784358,18.930358 L17.348358,18.478358 C13.0633991,22.1559671 6.63783226,21.7886928 2.79982327,17.6467888 C-1.03818571,13.5048847 -0.915701775,7.06999567 3.07714695,3.07714695 Z M10.520358,3.26035802 C6.50966617,3.26035802 3.25835802,6.51166617 3.25835802,10.522358 C3.25835802,14.5330499 6.50966617,17.7843692 10.520358,17.7843692 C12.4470926,17.7867503 14.295601,17.0224172 15.6580091,15.6600091 C17.0204172,14.297601 17.7847503,12.4490926 17.7823692,10.522358 C17.7823692,6.51166617 14.5310499,3.26035802 10.520358,3.26035802 Z"  fill="#FFFFFF" fill-rule="nonzero"></path>
              </g>
            </svg>    </span>
          <span  v-if="isSearchInputVisible "  class="fa fa-times" @click="clickclose"> <svg width="20px" height="20px" viewBox="0 0 33 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M0.463806901,2.7528069 C-0.1546023,2.1151116 -0.1546023,1.1015022 0.463806901,0.463806901 C1.1015022,-0.1546023 2.1151116,-0.1546023 2.7528069,0.463806901 L16.4918069,14.2248069 L30.2528069,0.462806901 C30.8892788,-0.135339581 31.8864689,-0.117347465 32.5009491,0.503369712 C33.1154293,1.12408689 33.1233503,2.12140785 32.5188069,2.7518069 L18.7818069,16.4928069 L32.5198069,30.2538069 C33.1243503,30.884206 33.1164293,31.8815269 32.5019491,32.5022441 C31.8874689,33.1229613 30.8902788,33.1409534 30.2538069,32.5428069 L16.4918069,18.7818069 L2.7538069,32.5428069 C2.1161116,33.1612161 1.1025022,33.1612161 0.464806901,32.5428069 C-0.1536023,31.9051116 -0.1536023,30.8915022 0.464806901,30.2538069 L14.1978069,16.4928069 L0.463806901,2.7528069 Z"  fill="#FFFFFF" fill-rule="nonzero"></path>
    </g>
</svg> </span>
        </div>





        <div class="buttons-nav-container">
          <button
            v-if="!isSearchInputVisible"
            ref="navbarToggler"
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
            v-on:click="clickout"
          >
            <svg width="25px" height="37px" viewBox="0 0 44 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M42.3405,24.906 C43.2575688,24.906 44.001,25.6494312 44.001,26.5665 C44.001,27.435302 43.3337654,28.1482631 42.4837743,28.220905 L42.3405,28.227 L1.6605,28.227 C0.743431173,28.227 9.9475983e-14,27.4835688 9.9475983e-14,26.5665 C9.9475983e-14,25.697698 0.667234626,24.9847369 1.5172257,24.912095 L1.6605,24.906 L42.3405,24.906 Z M42.3405,12.453 C43.2575688,12.453 44.001,13.1964312 44.001,14.1135 C44.001,14.982302 43.3337654,15.6952631 42.4837743,15.767905 L42.3405,15.774 L1.6605,15.774 C0.743431173,15.774 9.9475983e-14,15.0305688 9.9475983e-14,14.1135 C9.9475983e-14,13.244698 0.667234626,12.5317369 1.5172257,12.459095 L1.6605,12.453 L42.3405,12.453 Z M42.3405,0 C43.2575688,0 44.001,0.743431173 44.001,1.6605 C44.001,2.52930205 43.3337654,3.2422631 42.4837743,3.31490497 L42.3405,3.321 L1.6605,3.321 C0.743431173,3.321 9.9475983e-14,2.57756883 9.9475983e-14,1.6605 C9.9475983e-14,0.791697953 0.667234626,0.0787369037 1.5172257,0.006095026 L1.6605,0 L42.3405,0 Z"  fill="#FFFFFF" fill-rule="nonzero"></path>
              </g>
            </svg>
          </button>
        </div>
      </nav>
    </div>
  </div>
    <div class="collapse navbar-collapse" id="navbar">
      <div id="custom-navbar-collapse" class="custom-navbar-collapse">
        <ul class="navbar-nav mr-auto custom-nav-all">
          <div  class="custom-navbar-nav border-bottom"   @click.prevent="setCategory('trends');closetoggle=true;showSubMenu=false">
           <span  class="custom-mb-menu custom-font"   :class="{ 'active': currentCategory === 'trends' }"  >
                  Accueil
            </span>
          </div>


          <div class="custom-navbar-nav border-bottom" v-for="(navItem, index) of items" v-if="navItem.id !== 0" >
            <div class="cursor"   @click.stop="toggleNavbar(navItem.id); closetoggle=true;showSubMenu=false" >
              <span  class="custom-mb-menu custom-font"   :class="{ active: navItem.id === +currentTheme }" v-if=" navItem.children && navItem.children.length < 1 && index !==0"> {{navItem.title}}  </span>
            </div>
            <div class="dropdown show custom-mb-menu custom-font cursor" :class="{active: navItem.id === +currentTheme}" right data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"
                 v-on:click="withouttoggleNavbar(navItem.id);showSub(navItem.id,index+1,closetoggle) ; oldid=navItem.id ;selectindex = +index"  v-if="navItem.children && navItem.children.length > 1"  >
                  <span> {{navItem.title}}
                    <span class="fix-toggle">
                      <svg class="toggle-svg" :class="[{'activeIcon': +index === selectindex && showSubMenu && !closetoggle }]"  width="15px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                         <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-660.000000, -192.000000)" class="hoversvg" :class="[{'color-fill': +index === selectindex  && !closetoggle || navItem.id === +currentTheme }]" fill="#000000" fill-rule="nonzero">
                <g  transform="translate(0.000000, 105.000000)">
                  <g transform="translate(202.000000, 0.000000)">
                    <g  transform="translate(457.000000, 87.000000)">
                      <path d="M18.132,0.778 L10.373,8.539 L2.615,0.777 C2.24293482,0.419847143 1.65348351,0.42609371 1.28907072,0.791051213 C0.924657931,1.15600872 0.919291806,1.7454687 1.277,2.117 L9.7,10.546 L9.7,10.546 C9.87711431,10.7236415 10.1176495,10.8234839 10.3685,10.8234839 C10.6193505,10.8234839 10.8598857,10.7236415 11.037,10.546 L19.464,2.116 C19.7173766,1.88038432 19.821909,1.52523771 19.7365764,1.18992773 C19.6512437,0.854617749 19.3896609,0.592643362 19.054479,0.506809237 C18.719297,0.420975113 18.3639944,0.524976153 18.128,0.778 L18.132,0.778 Z" ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
                      </svg>
                    </span>
                  </span>
              <div class="dropdown-menu dropdownMenuLink">
                    <span class="dropdown-item" v-for="child in navItem.children"
                          :key="child.id"
                          @click.stop="toggleNavbar(child.id);closetoggle=true;showSubMenu=false"
                          :class="{ active: child.id === +currentTheme }"> {{child.title}}  </span>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';
  import ListItems from '~/node_modules/list-items/src/components/Component.vue';
  import Mixin from '@/mixins/Mixin';
import CustomMenu from './CustomMenu';
  import HasPermission from '../../directives/HasPermission.js';
  export default {
    name: 'CustomHeader',
    components: {
      SearchBar,
      ListItems,
      CustomMenu
    },
    mixins: [Mixin],
    directives: {
      HasPermission,
    },
    data() {
      return {
        collapse:false,

        selectindex:'',
        showSubMenu:true,
        oldid:'',
        closetoggle:false,
        ShowBar:false,
        children:[],
        NOT_LIST_THEME : process.env.NOT_LIST_THEME ? process.env.NOT_LIST_THEME : false,
        isSearchInputVisible: false,
        title: '',
        selectedLang: {},
        URL_LIVE : process.env.URL_LIVE ? process.env.URL_LIVE : false,
        langs: [
          {
            value: 'fr',
            text: 'FR',
            image:
              'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6IzQxNDc5QjsiIGQ9Ik0xNzAuNjY3LDQyMy43MjFIOC44MjhjLTQuODc1LDAtOC44MjgtMy45NTMtOC44MjgtOC44MjhWOTcuMWMwLTQuODc1LDMuOTUzLTguODI4LDguODI4LTguODI4ICBoMTYxLjgzOVY0MjMuNzIxeiIvPgo8cmVjdCB4PSIxNzAuNjciIHk9Ijg4LjI3NyIgc3R5bGU9ImZpbGw6I0Y1RjVGNTsiIHdpZHRoPSIxNzAuNjciIGhlaWdodD0iMzM1LjQ1Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBkPSJNNTAzLjE3Miw0MjMuNzIxSDM0MS4zMzNWODguMjczaDE2MS44MzljNC44NzUsMCw4LjgyOCwzLjk1Myw4LjgyOCw4LjgyOHYzMTcuNzkzICBDNTEyLDQxOS43Nyw1MDguMDQ3LDQyMy43MjEsNTAzLjE3Miw0MjMuNzIxeiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K',
          },
          {
            value: 'en',
            text: 'EN',
            image:
              'data:image/svg+xml;utf8;base64,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',
          },
        ],
        showLang: false,
      };
    },
    watch: {
      keyword(newVal) {
        this.title = newVal;
      },
    },
    computed: {
      ...mapGetters({
        items: 'themes/getAllThemes',
        currentTheme: 'videos/getCurrentTheme',
        currentCategory: 'videos/getCurrentCategory',
        keyword: 'videos/getKeyword',
        live: 'live/getLive',
        isFullWidth: 'layout/isFullWidth',
        isSideNav: 'layout/isSideNav',
        currentLogo: 'layout/getCurrentLogo',
        componentStyle: 'layout/getComponentStyle',
        IsSiteEmbed:'layout/getIsSiteEmbed',
        typeLogo:'layout/getTypeLogo'
      }),
      getLogo() {
        return this.currentLogo ? this.currentLogo : './static/logo.png';
      },
      showLogo(){
        if (!this.IsSiteEmbed && this.isFullWidth)
          return true;
        else
          return false;
      },

      getItems(){
        return Object.assign(this.items)
      }

    },
    props: {
      query: {
        type: String,
        default: '',
      },
    },
    methods: {
      ...mapActions('videos', ['setKeyword', 'setCurrentCategory']),
      ...mapActions('themes', ['fetchThemes']),
      ...mapActions('live', ['fetchLive']),
      showSub(id,index){
        this.closetoggle = false;
        if(this.oldid != id ) {
          this.showSubMenu=true
          return
        }
        if(id===index){
          this.showSubMenu = ! this.showSubMenu
        }
      },
      search(keyword) {
        this.setKeyword(keyword);
        this.$router.push({ name: 'home', params: { category: 'all' } });
        if (keyword !== '') {
          this.$router.push({ query: { q: keyword } });
        }
      },
      redirectLive() {
        location.replace(
          this.live && this.live.permalien_live
            ? this.live.permalien_live
            : process.env.URL_LIVE,
        );
      },
      keywordChanged(keyword) {
        // this.setKeyword(keyword);
      },
      searchInputBlurred(keyword) {
        this.isSearchInputVisible = !!keyword;
      },
      toggleSearchInput() {
        this.isSearchInputVisible = !this.isSearchInputVisible;
      },
      getSearchWord() {
        const query = this.$route.query.q;
        if (query) {
          this.setKeyword(query);
          this.title = query;
        }
      },
      toggleNavbar(id, category) {
        if(id!== this.$route.params.themeId)
        this.itemClicked(id, category);
        this.$refs.navbarToggler.click();
      },
      withouttoggleNavbar(id, category) {
        if(id !== this.$route.params.themeId)
        this.itemClicked(id, category);
      },
      changeLang(lang) {
        this.selectedLang = lang;
        this.$root.$i18n.locale = this.selectedLang.value;
        localStorage.setItem('lang-fo', this.selectedLang.value);
      },
      setCategory(category) {
        this.setCurrentCategory(category);
        this.toggleNavbar(0, category);
      },
      updateCurrentLanguage() {
        const userLang = localStorage.getItem('lang-fo');
        this.selectedLang = this.langs.find(l => l.value === userLang);
      },

      clickopen:function (e) {
        this.isSearchInputVisible = !this.isSearchInputVisible;

        e.preventDefault();
        document.getElementById('searchbar').classList.remove('collapsed')
      },
      clickclose:function (e) {
        this.isSearchInputVisible = !this.isSearchInputVisible;

        e.preventDefault();
        document.getElementById('searchbar').classList.add('collapsed')
      },
      clickout(){
        var customnavbar = document.querySelector('.custom-navbar-collapse');
        document.addEventListener('click', function(event) {
          var isClickInside = customnavbar.contains(event.target);
          if (isClickInside) {
            //
          } else {
            document.getElementById('navbar').classList.remove('show')

          }
        });
      }

    },
    created() {
      this.fetchThemes();
      if(this.URL_LIVE){
        setTimeout(() => {
          this.fetchLive({ duration: '500' });
        }, 200);
      }

      this.updateCurrentLanguage();
    },
    mounted() {
      this.getSearchWord();
      if(this.URL_LIVE){
        let duration = { duration: '500' };
        setInterval(() => {
          this.fetchLive(duration);
        }, 5000);
      }


    },
  };
</script>

<!--SHOULD BE NOT SCOPED-->
<style lang="scss">
  @import '../../assets/scss/variables';
  @import '../../assets/scss/logo';

  %search-input-shared {
    .search-input-container {
      flex: 1 0 0;
      &.full-width {
        padding: 1rem 16px 0 4rem;
      }
      &.side-nav {
        padding: 1rem 7rem 0 0;
        position: relative;
        .btnLive {
          position: absolute;
          right: 0;
          top: 0;
          margin: 1rem 0 0;
          font-weight: 500;
          color: var(--primary-color);
          svg path {
            fill: var(--primary-color);
          }
        }
      }
      .search-bar-container {
        --search-bar-input-width: 99%;
        --search-bar-input-height: 2.5em;
        --search-bar-input-border: none;
        --search-bar-input-radius: none;
        --search-bar-input-bg: transparent;
        --search-bar-btn-border: none;
        --search-bar-btn-bg: transparent;
        --search-bar-input-border-top: none;
        --search-bar-input-border-right: none;
        --search-bar-input-border-left: none;
        --search-bar-btn-radius: 0;
        --search-bar-btn-border-top: none;
        --search-bar-btn-border-right: none;
        --search-bar-btn-border-left: none;
        --search-bar-btn-float: left;
        --search-bar-input-text-size: 1rem;
        --search-bar-placeholder-color: #555555;
        --search-bar-input-text-color: #333;
        --search-bar-input-text-padding: 0 0 0 0.5em;
      }

      .search-bar {
        --search-bar-input-text-width: 95%;
        --search-bar-input-placeholder-color: #8e8e8e;
      }

      .icon {
        --search-bar-icon-width: 1em;
        --search-bar-icon-height: 2em;
        --search-bar-icon-color: #8e8e8e;
      }
    }
  }

  .header-container.custom-header {
    position: sticky;
    top: 0;
    z-index: 1002; // Player control-bar
    background: var(--secondary-color)!important;
    margin: 0 -15px;
    box-shadow: none!important;
    &.side-nav {
      padding: 0 15px;
    }
    .desktop-header {
      @extend %search-input-shared;
      .navbar-brand {
        padding: 0;
      }
      .list-items {
        --list-items-bg-color: var(--primary-color);
        .list-ul {
          display: flex;
          align-items: center;
          justify-content: start;
          --list-items-list-ul-bg-color: var(--primary-color);
          --list-ul-padding: 0.5em 15px;
          .list-li {
            position: relative;
            --list-number-items: 3.5;
            &:first-child {
              width: 2em;
              left:-1.5em;
              .item-name {
                display: block;
              }
              .activeBtn {
                background-color: var(--primary-color) !important;
              }
              .item:hover {
                background-color: var(--primary-color) !important;
              }
            }
            &:not(:first-child) {
              /*flex: 1 0 0;*/
              &:after {
                content: '';
                position: absolute;
                left: 0;
                top: calc(50% - 0.5em);
                height: 1em;
                border-right: 1px solid #0d1e2f;
                opacity: 0.3;
              }
              .item-icon-container {
                display: none;
              }
            }
            .item {
              --list-items-item-width: 100%;
              --list-items-item-padding: 0.2em 0;
              --list-items-item-name-color: #000000;
              --list-items-item-margin: 0;
              --list-items-item-over-textcolor:var(--primary-color) !important;;
              --list-items-item-over: rgba(255, 255, 255, 0.5);
              --list-items-item-border-radius: 0;
              --list-items-item-font-size: 0.9rem;
              &.activeBtn {
                background-color:var(--primary-color) !important;
                --list-items-item-name-color: #19589e !important;
                .item-name {
                  color: var(--secondary-color)!important;
                }
              }
              .item-icon-container {
                padding: 0.5em;
                --list-items-item-icon-container-margin: -0.5em 0 0 0.12em;
                --list-items-item-icon-container-height: 2.2em;
                svg {
                  width: 1.2em;
                  height: 1.2em;
                }
              }
              .item-name {
                font-weight: 700;
                --list-items-item-name-margin: 0.1em auto;
                --list-items-item-name-width: auto;
                --list-items-item-name-padding: 0 0.2em;
              }
            }
          }
        }
      };
      .sub{
        --list-items-bg-color: var(--primary-color);
        .list-ul {
          display: flex;
          align-items: center;
          justify-content: start;
          --list-items-list-ul-bg-color: var(--primary-color);
          --list-ul-padding: 0.5em 15px;
          .list-li {
            position: relative;
            --list-number-items: 3.5;
            height: auto;
            &:first-child {
              width: auto!important;
              left: 0em !important;
              color: black;
              .item-name {
                display: block;
              }
              .activeBtn {
                background-color: var(--primary-color) !important;
              }
              .item:hover {
                background-color: var(--primary-color) !important;
              }
            }
            &:not(:last-child) {
              /*flex: 1 0 0;*/
              &:after {
                content: '';
                position: absolute;
                left: 100%;
                top: calc(50% - 0.5em);
                height: 1em;
                border-left: 1px solid #0d1e2f!important;
                z-index: 3;
              }
              .item-icon-container {
                display: none;
              }
            }
            .item {
              --list-items-item-width: 100%;
              --list-items-item-padding: 0.2em 0;
              --list-items-item-name-color: #000000;
              --list-items-item-margin: 0;
              --list-items-item-over-textcolor:var(--primary-color) !important;;
              --list-items-item-over: rgba(255, 255, 255, 0.5);
              --list-items-item-border-radius: 0;
              --list-items-item-font-size: 0.9rem;
              &.activeBtn {
                background-color:var(--primary-color) !important;
                --list-items-item-name-color: #000000!important;
                .item-name {
                  color: var(--secondary-color)!important;
                }
              }
              .item-icon-container {
                padding: 0.5em;
                --list-items-item-icon-container-margin: -0.5em 0 0 0.12em;
                --list-items-item-icon-container-height: 2.2em;
                svg {
                  width: 1.2em;
                  height: 1.2em;
                }
              }
              .item-name {
                font-weight: 700;
                --list-items-item-name-margin: 0.1em auto;
                --list-items-item-name-width: auto;
                --list-items-item-name-padding: 0 0.2em;
              }
            }
          }
        }
      }
    }

    .mobile-header {
      padding: 0 14px;
      .logo-container {
        img {
          width: 35px;
          height: auto;
          margin-right: 1em;
        }
      }
      .navbar-toggler {
        border: none;
      }
      @extend %search-input-shared;
      .search-input-container {
        background-color:  var(--secondary-color) !important;
        right: 4em;
        top: 0.5em;
        width: 0;
        padding: 0;
        overflow: hidden;
        transition: all 0.3s ease;
        &.in {
          padding: 0 0 0 2em;
          width: calc(100vw - 4em);
        }
        .icon {
          display: none;
        }
      }
      .search-input-toggler {
        right: 4em;
        top: 1em;
        .icon {
          display: block;
          width: 1em;
          height: 1em;
          background-size: contain;
          background: no-repeat center;
          &.search {
            background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDMwLjIzOSAzMC4yMzkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwLjIzOSAzMC4yMzk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNMjAuMTk0LDMuNDZjLTQuNjEzLTQuNjEzLTEyLjEyMS00LjYxMy0xNi43MzQsMGMtNC42MTIsNC42MTQtNC42MTIsMTIuMTIxLDAsMTYuNzM1ICAgYzQuMTA4LDQuMTA3LDEwLjUwNiw0LjU0NywxNS4xMTYsMS4zNGMwLjA5NywwLjQ1OSwwLjMxOSwwLjg5NywwLjY3NiwxLjI1NGw2LjcxOCw2LjcxOGMwLjk3OSwwLjk3NywyLjU2MSwwLjk3NywzLjUzNSwwICAgYzAuOTc4LTAuOTc4LDAuOTc4LTIuNTYsMC0zLjUzNWwtNi43MTgtNi43MmMtMC4zNTUtMC4zNTQtMC43OTQtMC41NzctMS4yNTMtMC42NzRDMjQuNzQzLDEzLjk2NywyNC4zMDMsNy41NywyMC4xOTQsMy40NnogICAgTTE4LjA3MywxOC4wNzRjLTMuNDQ0LDMuNDQ0LTkuMDQ5LDMuNDQ0LTEyLjQ5MiwwYy0zLjQ0Mi0zLjQ0NC0zLjQ0Mi05LjA0OCwwLTEyLjQ5MmMzLjQ0My0zLjQ0Myw5LjA0OC0zLjQ0MywxMi40OTIsMCAgIEMyMS41MTcsOS4wMjYsMjEuNTE3LDE0LjYzLDE4LjA3MywxOC4wNzR6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
          }
          &.toggle {
            background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIxMi45ODIgMjEyLjk4MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEyLjk4MiAyMTIuOTgyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnIGlkPSJDbG9zZSI+Cgk8cGF0aCBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7IiBkPSJNMTMxLjgwNCwxMDYuNDkxbDc1LjkzNi03NS45MzZjNi45OS02Ljk5LDYuOTktMTguMzIzLDAtMjUuMzEyICAgYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBsLTc1LjkzNyw3NS45MzdMMzAuNTU0LDUuMjQyYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBjLTYuOTg5LDYuOTktNi45ODksMTguMzIzLDAsMjUuMzEyICAgbDc1LjkzNyw3NS45MzZMNS4yNDIsMTgyLjQyN2MtNi45ODksNi45OS02Ljk4OSwxOC4zMjMsMCwyNS4zMTJjNi45OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwbDc1LjkzNy03NS45MzdsNzUuOTM3LDc1LjkzNyAgIGM2Ljk4OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwYzYuOTktNi45OSw2Ljk5LTE4LjMyMiwwLTI1LjMxMkwxMzEuODA0LDEwNi40OTF6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
          }
        }
      }
      .dropdown-lang {
        margin-top: 5px;
      }
    }
  }
  .header-container.custom-header .desktop-header .sub .list-ul {
    display: inline-table!important;
  }
  nav.navbar {
    padding: 15px!important;
  }
  .navbarList {
    display: flex;
    width: 100%;
    padding-right: 25px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    min-height: 45px;
  }
  .list-items {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  .nav-link {
    &.router-link-active {
      color: var(--secondary-color) !important;
    }
  }

  @media (max-width: 575px) {
    .container {
      padding-right: 0;
      padding-left: 0;
    }
  }

  @media (min-width: 992px) {
    .navbarList {
      max-width: 960px;
    }
  }

  @media (min-width: 1200px) {
    .container,
    .navbarList {
      max-width: 1180px !important;
    }
  }

  @media (min-width: 1600px) {
    .container,
    .navbarList {
      max-width: 1400px !important;
    }
  }

  .navbar-container {
    background-color:  var(--primary-color);
    display: flex;
    justify-content: center;
  }

  /*
     * IE 11 Support
     */

  .search-bar-container {
    width: 100%;
    height: inherit;
    border-top: 2.5em;
    border-right: none;
    border-bottom: 1px solid #c4c5c6;
    border-left: none;
    border-radius: 0;
    background: transparent;
    opacity: 1;
    padding: 10px;
    outline: none;
  }
  .border-bottom{
    border-bottom: solid 1px #8e8e8e!important;
  }

  .search-bar {
    width: 95%;
    color: #333;
    padding: 0 0 0 0.5em;
    font-size: 1.2em!important;
  }

  .header-container.custom-header .icon {
    width: 1em;
    height: 1.5em;
    color: #8e8e8e;
    float: left;
  }

  .list-items {
    background-color: var(--primary-color);
    font-family: var(--list-items-font-family, sans-serif);
  }

  .list-ul {
    list-style-type: none;
    overflow: visible !important;
    margin: 0;
    padding: 0.5em 15px;
    background-color: var(--primary-color);
    width: 100%;
    vertical-align: middle;
  }

  .list-li {
    height: 100%;
    display: inline-block;
  }
  .btnLive {
    display: flex;
    align-items: center !important;
    border-radius: unset !important;
    color: #fff;

    svg path {
      fill: #fff;
    }
    #btnLiveGroupe {
      .big-arc {
        animation: hideShow 2s 1.5s ease infinite;
      }
      .small-arc {
        animation: hideShow 2s 1s ease infinite;
      }
    }
    &:disabled,
    &[disabled] {
      background: #407156 !important;
      border-color: #407156 !important;
      color: #22503d !important;
      opacity: 1;

      svg path {
        fill: #22503d;
      }
      #btnLiveGroupe {
        .big-arc {
          animation: none;
        }

        .small-arc {
          animation: none;
        }
      }
    }
  }

  .item {
    float: left;
    text-align: center;
    padding: 0.2em 0;
    font-size: 0.9rem;
    height: 100%;
    margin: 0;
    border-radius: 0;
    width: 100%;
    color: #ffffff;
    &.activeBtn {
      //background-color: #ffffff;
      color: var(--primary-color) !important;
      .item-name {
        color: var(--primary-color);
      }
    }
  }

  .item-icon-container {
    float: left;
    width: 30%;
    height: 2.2em;
    padding: 0;
    margin: -0.5em 0 0 0.12em;
  }

  .item-icon {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .item-name {
    float: left;
    width: auto;
    margin: 0.1em auto;
    padding: 0 0.2em;
  }

  .item:hover {
    background-color: var(--primary-color) !important;
    cursor: pointer;
    color: var(--secondary-color) !important;
   // fill: #fff;
  }
  .activeBtn {
    background-color: #e3e3e3;
    fill: #fff;
  }
  .mobileLiveButton {
    cursor: pointer;
    color: var(--primary-color);
    svg path {
      fill: var(--primary-color);
    }
  }

  @media all and (-ms-high-contrast: none) {
    .color-container {
      display: none !important;
    }
  }

  @keyframes hideShow {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .dropdown-lang {
    transform: translateY(10px);
    .dropdown-toggle,
    .dropdown-toggle:hover,
    .dropdown-toggle.show,
    .dropdown-toggle.active,
    .dropdown-toggle:active {
      background: none !important;
      color: #000 !important;
      border: none !important;
      display: flex;
      flex-direction: row;
      box-shadow: none !important;
    }
    .image_base64 {
      width: 20px;
    }

    .dropdown-image {
      margin-top: -10px;
    }

    .dropdown-text {
      font-family: sans-serif;
      font-size: 14px;
      font-weight: bold;
      color: #41479b;

      &.lang-current {
        margin-right: 7px;
      }
    }

    .dropdown-menu {
      min-width: 1rem;
    }
  }
  @media (max-width: 991px) {
    nav.navbar {
      padding: 0.5rem 0;
      padding-left: 15px;
    }
  }
  .logo {
    width: $width;
  }
  @media (max-width: 520px) {
    .logo-part1 {
      font-size: 15px;
      font-weight: 700;
      line-height: 40px;
      color: var(--secondary-color) !important;
    }
    .logo-part2 {
      font-size: 15px;
      font-weight: 200;
      line-height: 40px;
      color: var(--secondary-color) !important;

    }
  }
  .Connexion {
    background-color: rgba(255,255,255,0);
    height: 100%;
    width: 100%;
    margin-top: 0.1em!important;
    margin-left: 1.2em;
    font-family: "Roboto", Helvetica, Arial, serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20.0px;
    color: #fff;
  }
  .Rectangle {
    cursor: pointer;
    width: 149px;
    height: 40px!important;
    border-radius: 10px;
    border: solid 2px #ffffff;
    background-color: #52b8ba;
    margin-left: 2em;
  }

  @media screen and (min-width: 992px){
    .navbar-collapse.collapse.show{
      display: none!important;
    }

  }
  @media (max-width: 992px) {
    .navbar-container-sous-menu{
      display: none;
    }
    .navbar-collapse {
      position: absolute;
      top: 61px;
      right: 100%;
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      width: 108%;
      transition: all 0.3s ease;
      display: block;
      background-color:#22212180;
    }
    .navbar-collapse.collapsing {
      height: auto !important;
      margin-left: 50%;
      transition: all 0.3s ease;
      display: block;
    }
    .navbar-collapse.show {
      left: -15px;
    }
    .custom-navbar-collapse{
      background-color: #eeeff0;
      width: 80%;
      position: absolute;
      right: 0px;
      height: 100%;
    }
  }



  .title-menu{
    cursor: pointer;
    font-family: Raleway;
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-right: 2em;
    margin-top: 0.5em;
  }
  .title-menu:hover{
    color: var(--secondary-color ) !important;
  }
  .title-menu-active{
    color: var(--secondary-color ) !important;
  }
  .dropdown-menu{
    background-color:  var(--primary-color ) !important;
    border: 0px !important;
  }
  .dropdown-item:hover, .dropdown-item:focus {
    background-color:  var(--primary-color ) !important;
    color:var(--secondary-color ) !important; ;
  }
  .dropdown-item{
    font-family: Raleway;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .nav-item{
    padding-left: 2em;
  }
  .nav-link{
    color: #000000 !important;
    font-family: Raleway;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .nav-link:hover{
    color:var(--secondary-color ) !important; ;

  }

  .search-bar-container{
    width: 502px !important;
    height: 45px !important;
  }



  .header-container.custom-header .desktop-header .search-input-container .icon
  {
    --search-bar-icon-width: 1.5em!important;
  }
  .header-container.custom-header .desktop-header .search-input-container.rounded .search-bar-container{
    border-radius: 35px!important;
  }
  .header-container.custom-header .mobile-header .search-input-container.rounded .search-bar-container form {
  position: absolute;
  top: 1em;
  }




  @media screen and (min-width: 993px ) {
    .icon-cherch{
      display: block;
    }
  }



  @media screen and (max-width:992px ){
    .search-bar-container{
      left: 0em;
    }

    .search-bar{
      font-size: 1em !important;
    }
    .header-container.custom-header .mobile-header .search-input-container .icon{
      --search-bar-icon-width: 1em!important;
    }
    .header-container.custom-header .mobile-header .search-input-container.rounded .search-bar-container {
      width: 100%!important;
      position: absolute;
      top: 0px;
      height: 30px!important;
    }
    .header-container.custom-header .mobile-header .search-input-container.rounded .search-bar-container form {
      position: absolute!important;
      top: 0.2em!important;
    }
  }





  #searchbar
  {
    position: absolute;
     left: calc(100% - 50px);
    top: 1.5em;
  }

  #searchbar #sliding-panel-outer
  {
    display: inline-block;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 30px;
    width: calc(100vw - 100px);
    transition: width 0.4s ease;
  }

  #searchbar #sliding-panel-inner
  {
    width: 240px;
  }

  .search-label
  {

    width: calc(100% - 150px);
    display: flex;
    justify-content: flex-end;
  }

  .search-label.closelabel{
    width: calc(100% - 15px);
  }

  #searchbar .search-label
  {

    width: calc(100% - 150px);
    display: flex;
    justify-content: flex-end;
    height: 30px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 30px;
  }

  #searchbar .search-label .fa-times,
  #searchbar.collapsed .search-label .fa-search
  {
    display: inline-block;
  }
  #searchbar .search-label .fa-search,
  #searchbar.collapsed .search-label .fa-times
  {
    display: none;
  }

  #searchbar.collapsed #sliding-panel-outer
  {
    width: 0px;
  }


  .custom-navbar-nav{
    margin-right: 3em!important;
    margin-left: 3em!important;
  }
  .custom-navbar-nav{
    padding-top: 1em;
    padding-bottom: 1em;
  }
  #navbar{
    height: 100%;
    z-index: 999;
    position: fixed!important;
  }

  .custom-mb-menu:hover {
    color: var(--secondary-color)!important;
  }
.active{
  color: var(--secondary-color)!important;

}
  .activeIcon{
    transform: rotate(180deg) !important;
  }
  .notActiveIcon{
    transform: rotate(0deg);
  }
  .color-fill{
    fill: var(--secondary-color ) !important;
  }
  div[aria-expanded=true]{
    color:var(--secondary-color ) !important;
  }

  .fix-toggle{
    position: absolute;
    left: 90%;
  }
  .dropdownMenuLink{
    position: relative!important;
    transform: none!important;
  }
  .custom-font{
    font-family: Raleway!important;
    font-size: 14px;
    font-weight: normal!important;
  }
  .cursor{
  cursor: pointer;
  }
  .custom-navbar-nav:hover{
    color: var(--secondary-color)!important;
    .hoversvg{
      fill: var(--secondary-color ) !important;
    }
  }
  .header-container.custom-header .desktop-header .sub .list-ul .list-li:not(:last-child):after {
    opacity: 0.3!important;
  }
  .separator{
    border-bottom: solid 1px;
  color: white;
  top: 46px;
  position: relative;
  z-index: 6;}
</style>



// WEBPACK FOOTER //
// src/components/Custom/CustomHeader.vue